module.exports = __webpack_public_path__ + "img/finanse.cfc78b28.svg";